// extracted by mini-css-extract-plugin
export default {"selectButton":"AzureGroupSelector_selectButton__kJhQ2","skeletonGroup":"AzureGroupSelector_skeletonGroup__cF-Hq","list":"AzureGroupSelector_list__fHaEZ"};